import React from 'react';
import SubInfo from '../common/SubInfo';
import Tags from '../common/Tags';
import './PostList.scss';
import WritePostButtonWrapper from './WritePostButtonWrapper';
import { Link } from 'react-router-dom';

const PostItem = React.memo(({ post }) => {
  const { publishedDate, user, tags, title, body, _id } = post;
  return (
    <div className="PostItem">
      <h2>
        <Link to={`/@${user.username}/${_id}`}>{title}</Link>
      </h2>
      <SubInfo username={user.username} publishedDate={publishedDate} />
      <Tags tags={tags} />
      <p>{body}</p>
    </div>
  );
});

const PostList = ({ posts, loading, error, showWriteButton }) => {
  //에러 발생시
  if (error) {
    return <PostList>에러가 발생했습니다. </PostList>;
  }

  return (
    <div className="PostList">
      <WritePostButtonWrapper>
        {showWriteButton && (
          <Link className="WritePostButton" to="/write">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            새 글 작성하기
          </Link>
        )}
      </WritePostButtonWrapper>
      {/* 로딩 중이 아니고, 포스트 배열이 존재할 때만 보여줌 */}
      {!loading && posts && (
        <div>
          {posts.map((post) => (
            <PostItem post={post} key={post._id} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PostList;
